import { XMarkIcon } from '@heroicons/react/24/outline';
import { IconButton } from '@mui/joy';

import dayjs from 'dayjs';
import { useState } from 'react';

import { formatDuration } from '@/utils/format-duration';

export function LicenseExpiredBanner(props: { expireDate: dayjs.Dayjs }) {
  const [visible, setVisible] = useState(true);
  const timeUntilExpire = formatDuration(new Date(), props.expireDate);

  const expired = props.expireDate.unix() <= dayjs().unix();

  return visible ? (
    <div className="flex items-center justify-center gap-2 bg-warning-primary px-4 py-2 text-center text-sm text-ls-black">
      <div className="flex grow items-center justify-center gap-2">
        {`License ${
          expired ? 'expired' : `expires in ${timeUntilExpire}`
        }. Contact sales@langchain.dev to renew.`}
      </div>
      <IconButton
        size="sm"
        variant="plain"
        sx={{ '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.5)' } }}
        onClick={() => setVisible(false)}
      >
        <XMarkIcon className="m-1 text-white" />
      </IconButton>
    </div>
  ) : null;
}
